export default "https://fiverr-res.cloudinary.com/npm-assets/layout-service/save_favorite.56410a2.png";